import { WeekDayButton } from './styled'
import { Box, Tooltip } from '@chakra-ui/react'

const week = [
    { title: 'M', value: 'MONDAY', tooltip: 'Monday'  },
    { title: 'T', value: 'TUESDAY', tooltip: 'Tuesday'  },
    { title: 'W', value: 'WEDNESDAY', tooltip: 'Wednesday'  },
    { title: 'T', value: 'THURSDAY', tooltip: 'Thursday'  },
    { title: 'F', value: 'FRIDAY', tooltip: 'Friday'  },
    { title: 'S', value: 'SATURDAY', tooltip: 'Saturday'  },
    { title: 'S', value: 'SUNDAY', tooltip: 'Sunday'  }
]

export const WeekDaySelector = ({ multiDay, selectedDays, onChange }) => {
    const handleChange = (day) => {
        if (multiDay) {
            const newSelected = selectedDays.includes(day)
                ? selectedDays.filter((d) => d !== day)
                : [...selectedDays, day]
            onChange(newSelected)
        } else {
            onChange([day])
        }
    }

    return (
        <Box display="flex" flex justifyContent="center">
            {week.map((day, index) => (
                <Tooltip
                    key={day.value}
                    hasArrow
                    label={day.tooltip}>
                    <WeekDayButton
                        mx={2}
                        sx={{ width: '40px', height: '40px' }}
                        colorScheme={selectedDays.includes(day.value) ? 'orange' : undefined}
                        onClick={() => handleChange(day.value)}
                    >
                        {day.title}
                    </WeekDayButton>
                </Tooltip>
            ))}
        </Box>
    )
}
